import { cca_config } from '@/config';

export default {
    name: 'bon-consultation-print',
    components: {},
    props: {
        selected_bon: Object,
        total_a_payer: Number,
        total_du: Number,
        total_taxe_specifique: Number
    },
    data() {
        return {
            nom_clinique: '',
            filename: ''
        }
    },

    computed: {

    },

    mounted() {
        this.nom_clinique = cca_config.NOM_CLINIQUE
        const tmpstamp = this.current_date.getTime()
        this.filename = "Bon consultation_"+this.selected_bon.info_bon_consultation.nom_patient+tmpstamp
    },

    methods: {
        printBon() {
            window.print()
        }
    }
}


